var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectie2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 41L75 41",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 77L75 77",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0002 77.5L75.0002 40.5",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.500002 77.5L0.500002 40.5008",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8835 52.5455V70H17.7216V52.5455H20.8835ZM42.4396 62.6619L30.7805 68.0483V65.0227L39.0646 61.4688L38.9709 61.6307V61.2386L39.0646 61.4006L30.7805 57.8466V54.821L42.4396 60.2074V62.6619ZM58.5881 62.6619L46.929 68.0483V65.0227L55.2131 61.4688L55.1193 61.6307V61.2386L55.2131 61.4006L46.929 57.8466V54.821L58.5881 60.2074V62.6619Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectie2);
export default __webpack_public_path__ + "static/media/protectie_2.3ce05859831cc191398e43a5c617c928.svg";
export { ForwardRef as ReactComponent };